module.exports = __webpack_public_path__ + "assets/img/learning2.300febb2.png";